// Copyright (c) 2016 Deere & Company

import './index.scss';
import PartRequestsSearchMain from './part-requests-search';
import actionCreators from '../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    ...state.partReturns.search,
    selectedAccounts: state.user.details.settings.dealer.accounts.selectedAccounts
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {location, routeParams} = parentProps;

    return {
        ...stateProps,
        actions: {
            ...dispatchProps
        },
        queryParams: location.query,
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(PartRequestsSearchMain);



// WEBPACK FOOTER //
// ./src/part-requests/search/components/index.js